import { SaleFormInput } from '@src/core/buyerApiClient';

/**
 * Stable identity of a form input group. The first hash works because `organizeFormInputs`
 * has already sorted the group by `formInput.sequence`.
 */
export const formInputGroupKey = (inputs: SaleFormInput[]): string => inputs[0]?.hash ?? '';
